<div class="progress-wrapper">
  <div
    class="status"
    [ngClass]="{ 'circle-style':  isCircleStyle, 'completed': progress >= 100 }"
    [ngStyle]="{ 'background-color': color, width: progress + '%' }"
    *ngIf="progress > 0"
  ></div>
</div>
